module.exports = __webpack_public_path__ + "static/media/thumbs-down.147d2475.svg";